module.exports = __webpack_public_path__ + "img/sticker-mule2.037f4766.png";